// Shared Framer Motion variants + a masked line-reveal helper.

export const easeSoft = [0.22, 1, 0.36, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 34 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.85, ease: easeSoft, delay: i * 0.08 },
  }),
};

export const staggerParent = {
  hidden: {},
  show: { transition: { staggerChildren: 0.09, delayChildren: 0.05 } },
};

// Masked line reveal (word/line rises from behind an overflow-hidden mask).
export const maskLine = {
  hidden: { y: "110%" },
  show: (i = 0) => ({
    y: "0%",
    transition: { duration: 1, ease: easeSoft, delay: 0.25 + i * 0.12 },
  }),
};

export const viewportOnce = { once: true, amount: 0.25 };
